import React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';

import { GET_USERS } from "../../../query/queries";
import UserCard from './user-card';
import UserCardLogged from './user-card-logged';

import styles from './Conversations.css';

const mapStateToProps = state => {
  return { user: state.user };
};

const ConnectedConversations = (props) => {
  let mainContainerTheme = '';
  if(props.user.theme === 'DARK') {
    mainContainerTheme = styles.mainContainerDarkTheme;
  }
  return <Query query={GET_USERS}
    pollInterval={400}>
    {({ error, loading, data: { allUsers } }) => {
      if (loading) return <div className={styles.mainContainer}>
        <label className={styles.loading}>Cargando...</label>
      </div>
      if (error) return 'OH NO, ERROR!';
      return <div className={[styles.mainContainer, mainContainerTheme].join(' ')}>
        <UserCardLogged user={props.user} />
        {allUsers.map(user => {
          if (user.username !== props.user.username) {
            return <UserCard user={user} key={user.id} theme={props.user.theme}/>
          }
        })}
      </div>
    }}
  </Query>
}

const Conversations = connect(mapStateToProps)(ConnectedConversations);

export default Conversations;


// WEBPACK FOOTER //
// ./src/pages/chat/conversations/Conversations.jsx